module.exports = __webpack_public_path__ + "static/img/memcateDefault.ab47d6f0.png";